import { MenuItem, Select } from "@mui/material";
import i18next from "i18next";
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { DefaultSelectProps } from "../../services/common/Constants";

const AttributeBooleanInput = ({ setSelectedAttribute = () => {}, save = () => {} }) => {
  const formMethods = useFormContext();
  const [isFocused, setIsFocused] = useState(true);

  useEffect(() => {
    if (!isFocused) {
      setSelectedAttribute(null);
      save();
    }
    // eslint-disable-next-line
  }, [isFocused]);

  return (
    <Controller
      control={formMethods.control}
      name="value"
      render={({ field }) => (
        <Select
          {...field}
          id="tp-attribute-select-id"
          variant="outlined"
          displayEmpty
          autoFocus
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={(event) =>
            formMethods.setValue("value", event.target.value)
          }
          MenuProps={DefaultSelectProps.MenuProps}
          sx={{
            border: "none",
            borderRadius: "0 12px 12px 0",
            fontSize: "14px",
            paddingRight: "16px",
            height: "100%"
          }}
        >
          <MenuItem key={"notSpecified"} value={null}>
            <em>{i18next.t("notSpecified")}</em>
          </MenuItem>
          <MenuItem key="true" value="true">
            {i18next.t("yes")}
          </MenuItem>
          <MenuItem key="false" value="false">
            {i18next.t("no")}
          </MenuItem>
        </Select>
      )}
    />
  );
};
export default AttributeBooleanInput;
